<template>
  <svg
    width="144"
    height="144"
    viewBox="0 0 144 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M71.718 12C38.79 12 12 38.916 12 72C12 105.084 38.916 132 72 132C105.084 132 132 105.084 132 72C132 38.916 104.958 12 71.718 12ZM72 120C45.534 120 24 98.466 24 72C24 45.534 45.402 24 71.718 24C98.346 24 120 45.534 120 72C120 98.466 98.466 120 72 120Z"
      fill="#9D57F4"
    />
    <path d="M66 42H78V84H66V42ZM66 90H78V102H66V90Z" fill="#9D57F4" />
  </svg>
</template>

<script>
export default {
  name: 'ErrorCircle',
};
</script>
